import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as VueGoogleMaps from "vue2-google-maps";
import firebase from 'firebase/compat/app'

const firebaseConfig = {
  apiKey: "AIzaSyCUiUHJ7N4cPkQIYQSU5uneSRST15pjqbs",
  authDomain: "ffgs-simulator-v2.firebaseapp.com",
  databaseURL: "https://ffgs-simulator-v2-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ffgs-simulator-v2",
  storageBucket: "ffgs-simulator-v2.appspot.com",
  messagingSenderId: "884711222098",
  appId: "1:884711222098:web:4b19bb34c1094eb25da88b"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCUHgcn-6Ps-R7duzyOl67aCFr9IsOWgTc",
  }
},firebase);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
